import { registerSW } from 'virtual:pwa-register'

type UpdateSW = (reloadPage?: boolean) => Promise<void>
type NeedRefreshHandler = (updateSW: UpdateSW) => void
type OfflineReadyHandler = () => void

const needRefreshHandlers = new Set<NeedRefreshHandler>()
const offlineReadyHandlers = new Set<OfflineReadyHandler>()

let isRegistered = false
let updateSWRef: UpdateSW | null = null
let offlineReadySeen = false

export function setupServiceWorker() {
  if (isRegistered || typeof window === 'undefined' || !('serviceWorker' in navigator)) return
  isRegistered = true

  let updateSW: UpdateSW | undefined
  updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      const applyUpdate = updateSW
      if (!applyUpdate) return
      updateSWRef = applyUpdate
      needRefreshHandlers.forEach((handler) => handler(applyUpdate))
    },
    onOfflineReady() {
      offlineReadySeen = true
      offlineReadyHandlers.forEach((handler) => handler())
    },
  })
}

export function onNeedRefresh(handler: NeedRefreshHandler) {
  needRefreshHandlers.add(handler)
  if (updateSWRef) handler(updateSWRef)
  return () => needRefreshHandlers.delete(handler)
}

export function onOfflineReady(handler: OfflineReadyHandler) {
  offlineReadyHandlers.add(handler)
  if (offlineReadySeen) handler()
  return () => offlineReadyHandlers.delete(handler)
}
